module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('social-post', {
    attrs: {
      "channels": _vm.channels,
      "post": _vm.post,
      "editPost": _vm.isEditing
    },
    on: {
      "send": _vm.onSendPost,
      "update": _vm.onUpdatePost,
      "delete": _vm.onDeletePost,
      "close": _vm.onClose
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e83d387","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/social/SocialPostsContainer.vue
// module id = 3354
// module chunks = 3